const globalStrings = {
  gamesManagement: "Gestionarea jocurilor",
  createGame: "Creeaza un joc nou",
  gameName: "Numele jocului",
  createdAt: "creat la",
  account: "cont",
  accounts: "conturi",
  player: "jucator",
  playerName: "Prenumele jucatorului",
  players: "jucatori",
  create: "Creeaza",
  submit: "Valideaza",
  startHexploit: "Porneste Hexploit",
  email: "Email",
  success: "Personajele tale au fost create cu succes!",
  delete: "Sterge",
  addCharacter: "Adauga un personaj",
  characterName: "Numele personajului",
  joinGame: "Alatura-te jocului",
  charactersCreation: "Crearea personajelor",
  goodLuck: "Foloseste-ti imaginatia!",
  accountTitle: "Contul meu",
  accountEmailVerified: "Email verificat",
  accountEmailValidationRequired: "Validare necesara",
  accountEmailNotValidated: "Emailul tau nu a fost inca validat",
  accountSendValidationEmail: "Trimite email de validare",
  accountGeneralInfo: "Informatii generale",
  accountEmailPlaceholder: "email@adresa.com",
  accountNewsletterLabel: "Abonare la newsletter",
  accountNewsletterEnableConfirmTitle: "Confirma abonarea",
  accountNewsletterEnableConfirmBody:
    "Continuand, accepti sa primesti emailuri cu informatii si noutati despre Hexploit.",
  accountNewsletterDisableConfirmTitle: "Confirma dezabonarea",
  accountNewsletterDisableConfirmBody: "Esti sigur ca nu mai vrei sa fii informat despre noutati?",
  accountNewsletterConfirmCancel: "Anuleaza",
  accountNewsletterConfirmConfirm: "Confirma",
  accountSaveChanges: "Salveaza modificarile",
  accountSecurityTitle: "Securitate",
  accountNewPasswordLabel: "Parola noua",
  accountNewPasswordPlaceholder: "Parola noua...",
  accountPasswordConfirmationLabel: "Confirma parola noua",
  accountPasswordConfirmationPlaceholder: "Confirma parola noua...",
  accountChangePassword: "Schimba parola",
  accountGamesTitle: "Jocurile mele",
  accountGamesCount: "jocuri",
  accountNoGames: "Nu exista jocuri in desfasurare momentan.",
  accountViewGame: "Vezi jocul",
  accountUpdateSuccess: "Informatiile au fost actualizate",
  accountPasswordMismatch: "Confirmarea parolei nu corespunde",
  accountWelcomeEmailSubject: "Bun venit in Hexploit",
  accountParticipantsLabel: "participanti",
  accountCharactersLabel: "personaje",
  accountDeletePrompt: "Daca nu mai doresti sa fii inregistrat la A2Z eSanté, ne poti cere sa",
  accountDeleteLinkText: "stergem contul",
  accountDeleteSuffix: "si toate datele lui.",
  accountValidationEmailSentTitle: "Email trimis",
  accountValidationEmailSentBody: "Un email de validare a fost trimis.",
  accountPasswordResetSentTitle: "Email trimis",
  accountPasswordResetSentBody: "Un email pentru schimbarea parolei a fost trimis.",
  accountNewsletterSavedTitle: "Preferinte salvate",
  accountNewsletterSavedBody: "Preferintele tale pentru newsletter au fost actualizate.",
  accountMetaTitle: "Hexploit - Contul meu",
  gamesAdminDescription: "Creeaza un joc nou si gestioneaza sesiunile in curs.",
  gamesAdminBadge: "Admin",
  gamesInProgressTitle: "Jocuri create",
  gamesCountLabel: "jocuri",
  gamesFilterDateLabel: "Filtreaza dupa data",
  gamesFilterDatePlaceholder: "Alege o data",
  gameJoinBadge: "Alatura-te jocului",
  gameHeaderLine1: (name: string) => `Partida Hexploit: ${name}`,
  gameHeaderLine2: (date: string, time: string) => `din ${date} la ${time}`,
  gameJoinQrHint: "Scaneaza acest cod QR pentru a te alatura jocului.",
  gameOpenLink: "Deschide linkul",
  gameShareLink: "Distribuie linkul",
  gameShareTitle: "Alatura-te Hexploit",
  gameParticipantsTitle: "Participanti",
  gameCharactersTitle: "Personaje",
  gameMyCharactersTitle: "Personajele mele",
  gameParticipantNameLabel: "Nume:",
  gameParticipantCharacterLabel: "Personaj:",
  gameParticipantEmailLabel: "Email:",
  gameManageParticipant: "Gestioneaza acest participant",
  gameDeleteCharacterTitle: "Stergi personajul?",
  gameDeleteCharacterBody: "Aceasta actiune este definitiva.",
  gameDeleteCharacterConfirm: "Sterge",
  gameDeleteCharacterCancel: "Anuleaza",
  gameDeleteCharacterAria: "Sterge personajul",
  gameManageCharacter: "Editeaza personajul",
  joinIntro: "Pentru a testa Hexploit inaintea tuturor, introdu adresa ta de email.",
  joinEmailLabel: "Adresa ta de email",
  joinEmailDescription: "Creand contul, vei putea regasi toate jocurile tale si personajele asociate",
  joinEmailPlaceholder: "email@exemplu.com",
  joinReadyBadge: "Gata de joc",
  joinReadyDescription: "Te vei alatura acestui joc si vei accesa crearea personajelor.",
  joinLogoAlt: "Logo Hexploit",
  manageIntro: "Adauga si personalizeaza personajele echipei tale.",
  manageCharacterLabel: (index: number) => `Personaj ${index}`,
  manageDeleteCharacterAria: "Sterge acest personaj",
  managePlayerNamePlaceholder: "Prenumele jucatorului",
  manageCharacterNamePlaceholder: "Numele personajului, fii creativ!",
  manageDescriptionLabel: "Descriere",
  manageDescriptionPlaceholder: "Descrie acest personaj",
  manageDictationAria: "Dictioneaza descrierea",
  manageImageLabel: "Fotografia Alchimiei Sufletului",
  manageChangeImage: "Schimba imaginea",
  manageChooseImage: "Alege o imagine",
  manageResetImage: "Reset",
  manageNoFileSelected: "Niciun fisier selectat",
  manageSoulLabel: "Suflet",
  manageAppearanceLabel: "Aspect",
  managePersonalityLabel: "Personalitate",
  managePowersLabel: "Puteri",
  manageWeaknessesLabel: "Slabiciuni",
  manageAddCharacterHint: "Apasa pentru a crea un personaj nou",
  manageSubmitCharacters: "Creeaza avatarurile",
  manageChooseCardLabel: "Alege o carte",
  manageChooseCardTitle: (label: string) => `Alege o carte · ${label}`,
  manageSearchCardPlaceholder: "Cauta o carte",
  manageClearSelection: "Sterge selectia",
  manageToastAccountCreatedTitle: "Cont creat",
  manageToastAccountCreatedBody: "Contul tau a fost creat. A fost trimis un email de validare.",
  manageToastAccountCreatedBodyShort: "Contul tau tocmai a fost creat. A fost trimis un email de validare.",
  manageToastSavedTitle: "Modificarile au fost salvate",
  manageToastSavedBody: "Personajele tale au fost salvate.",
  manageToastAutosaveTitle: "Salvare automata",
  manageToastAutosaveBody: "Modificarile au fost salvate.",
  manageFeedbackTitle: "Ce parere ai despre joc? Feedback-ul tau este foarte important pentru noi!",
  manageFeedbackCta: "Da feedback (2 min)",
  manageEmailReminderLine1:
    "Verifica emailul; vei gasi un link catre contul tau Hexploit pentru a regasi jocul pe care tocmai l-ai jucat.",
  manageEmailReminderLine2: "Daca ti-a placut jocul, urmareste-ne pe retelele sociale ca sa nu ratezi nimic!",
  manageInstagramAria: "Hexploit Instagram",
  manageDiscordAria: "Hexploit Discord",
  manageYoutubeAria: "Hexploit Youtube",
  manageLogoAlt: "Hexploit",
  emptyValue: "—",
  resetPasswordTitle: "Hexploit - Parola noua",
  resetPasswordHeading: "Reseteaza parola",
  resetPasswordPasswordLabel: "Parola",
  resetPasswordPasswordPlaceholder: "Parola ta...",
  resetPasswordPasswordConfirmationLabel: "Confirma parola",
  resetPasswordPasswordConfirmationPlaceholder: "Confirma parola ta...",
  resetPasswordCancel: "Anuleaza",
  resetPasswordSubmit: "Trimite",
  resetPasswordInvalidPassword: "Parola invalida",
  resetPasswordInvalidConfirmation: "Confirmarea parolei este invalida",
  resetPasswordInvalidLink: "Link de resetare invalid",
  resetPasswordInvalidEmailOrCode: "Email sau cod invalid",
  signupTitle: "Hexploit - Creare cont",
  signupHeading: "Creeaza un cont",
  signupEmailLabel: "Email",
  signupEmailPlaceholder: "email@adresa.com",
  signupPasswordLabel: "Parola",
  signupPasswordPlaceholder: "Parola ta...",
  signupPasswordConfirmationPlaceholder: "Confirma parola",
  signupNewsletterLabel: "Ma abonez la newsletter pentru a urmari progresul jocului",
  signupSubmit: "Creeaza un cont",
  signupHaveAccount: "Ai deja un cont?",
  signupLoginLink: "Autentificare",
  signupSuccess: "Contul tau a fost creat. Vei primi un email de validare. Verifica SPAM-ul.",
  signupPasswordMismatch: "Confirmarea parolei nu corespunde",
  signupGenericError: "A aparut o eroare. Te rugam sa incerci din nou.",
  signupEmailExists: "Exista deja un cont cu acest email",
  loginTitle: "Hexploit - Autentificare",
  loginHeading: "Autentificare",
  loginEmailLabel: "Email",
  loginEmailPlaceholder: "email@adresa.com",
  loginPasswordLabel: "Parola",
  loginPasswordPlaceholder: "Parola ta...",
  loginForgotPassword: "Ai uitat parola",
  loginSubmit: "Autentificare",
  loginNoAccount: "Nu ai inca un cont?",
  loginCreateAccountLink: "Creeaza un cont",
  loginInvalidCredentials: "Email sau parola incorecta",
  loginTooManyAttempts: "Prea multe incercari intr-un timp scurt, te rugam sa contactezi team@hexploit.fr",
  mailVerificationTitle: "Hexploit - Verificare email",
  navSiteLink: "Hexploit.fr",
  navGames: "Jocuri",
  navAccount: "Contul meu",
  navLanguage: "Limba",
  footerTagline: "Hexploit - si daca a crea povesti ar deveni un joc?",
  footerVideoRules: "Reguli video",
  footerContact: "Contacteaza-ne",
  footerInstagramAria: "Urmareste-ne pe Instagram",
  footerYoutubeAria: "Canalul Youtube Hexploit",
  footerFacebookAria: "Urmareste-ne pe Facebook",
};

export default globalStrings;
